import { createStore } from "vuex";
import axios from "axios";

export default createStore({
  state: {
    requestCode: {
      code: null,
      remake: false,
    },
    current_parts_id: "022",
    current_size_id: null,
    id_holder: {},
    selected_parts_types: {},
    selected_parts_class: "",
    selected_parts_position: {},
    selected_element_id: {},
    result: {
      b_prices: "",
      prices: "",
      qty: {},
      row_data: "",
      param: {
        s_luck: 0,
        s_love: 0,
        s_gold: 0,
        s_job: 0,
        s_dream: 0,
        s_health: 0,
        s_heal: 0,
        s_relation: 0,
        s_guard: 0,
        s_mind: 0,
      },
      yoyaku: null,
      url: "",
      remake_code: "",
    },
    isLoadingPrice: true,
    selectedLabelCode: "all",
    selectedArrangeType: null,
  },
  mutations: {
    update_parts_id(state, id) {
      state.current_parts_id = id;
    },
    update_size_id(state, id) {
      state.current_size_id = id;
    },
    update_id_holder(state, data) {
      state.id_holder = data;
    },
    updateSelectedLabelCode(state, code) {
      state.selectedLabelCode = code;
    },
    updateselectedArrangeType(state, code) {
      state.selectedArrangeType = code;
    },
    /**
     * パーツIDを受け取って、選択中のパーツを更新する
     */
    update_id_holder_by_selected_parts(state, id) {
      let holder = state.id_holder;
      let arr = Object.keys(state.selected_parts_position).length
        ? state.selected_parts_position
        : false;

      if (arr) {
        for (let item in arr) {
          holder[arr[item].key][arr[item].k] = id;
        }
        this.commit("update_id_holder", holder);
      }
    },
    /**
     * サイズキーとパーツ位置キーを受け取って、パーツを更新する
     */
    update_selected_parts_id(state, key) {
      let size = key.key;
      let position = key.k;
      state.id_holder[size][position] = state.current_parts_id;
    },
    /**
     * タイプとアレンジのキーリストを受け取って、選択中のパーツタイプリストを更新する
     */
    update_selected_parts_types(state, type_arrange) {
      let parts_types = {};

      for (let size_id in state.selected_parts_position) {
        let k = state.selected_parts_position[size_id].k;
        let key = state.selected_parts_position[size_id].key;
        let itemk = type_arrange[key][k][0];
        parts_types[itemk] = true;
      }

      state.selected_parts_types = parts_types;
    },
    /**
     * デフォルトパーツタイプを受け取って、パーツクラスを更新する
     */
    update_selected_parts_class(state, default_parts_types) {
      let types = !Object.keys(state.selected_parts_types).length
        ? default_parts_types
        : state.selected_parts_types;

      let style = "";
      for (const property in types) {
        style = types[property] ? style + "bt_" + property + " " : "";
      }

      state.selected_parts_class = style;
    },
    /**
     * サイズキーとパーツ位置キーを受け取って、選択中のパーツ位置を更新する
     */
    update_selected_parts_position(state, data) {
      let string = data.keys.key + "-" + data.keys.k;
      if (data.checked) {
        state.selected_parts_position[string] = data.keys;
      } else {
        delete state.selected_parts_position[string];
      }
    },
    /**
     * 選択中のパーツ位置を初期化する
     */
    reset_selected_parts_position(state) {
      state.selected_parts_position = {};
    },
    update_bto_result(state, data) {
      state.result = data;
    },
  },
  actions: {
    update_id_holder(context, data) {
      context.commit("update_id_holder", data);
    },
    update_selected_parts_id(context, key) {
      context.commit("update_selected_parts_id", key);
    },
    update_selected_parts_types(context, types) {
      context.commit("update_selected_parts_types", types);
    },
    update_selected_parts_class(context, types) {
      context.commit("update_selected_parts_class", types);
    },
    update_selected_parts_position(context, data) {
      context.commit("update_selected_parts_position", data);
    },
    /**
     * アクセサリ商品オブジェクトとデザインIDリストを受け取って、BTO結果を更新する
     */
    async update_bto_result({ commit, state }, data) {
      if (
        !("jewelleryItemId" in data) ||
        !("itemCode" in data) ||
        !("designId" in data)
      ) {
        return false;
      }

      state.isLoadingPrice = true;

      let size_key = "size_" + state.current_size_id;
      let design_id = data.designId[size_key];

      let param = {
        id_holder: state.id_holder[size_key],
        item_id: data.jewelleryItemId,
        design_id: design_id,
        size_id: state.current_size_id,
        item_code: data.itemCode,
      };
      const result = await axios.post(
        process.env.VUE_APP_LIT_REST_ROUTE + "/wp-json/litec/v2/btoresult/",
        param
      );

      commit("update_bto_result", result["data"]);

      state.isLoadingPrice = false;
    },
  },
  modules: {},
});
